/* Registers a Unicode font on a jsPDF instance so translated (Gujarati /
   Hindi) text renders in the downloaded PDF. jsPDF's built-in fonts only
   cover Latin, so without this the gu/hi glyphs come out as garbage.

   The font binaries are lazy-loaded (dynamic import) so they ship in a
   separate chunk and don't bloat the main bundle — they are only fetched
   when a non-English PDF is actually generated.

   Returns the font-family name to pass to pdf.setFont(name, style).
   For English it returns 'helvetica' (jsPDF default) and loads nothing. */
export async function registerPdfFont(pdf, lang) {
  let mod
  if (lang === 'gu') mod = await import('./fonts/notoGujarati')
  else if (lang === 'hi') mod = await import('./fonts/notoDevanagari')
  else return 'helvetica'

  pdf.addFileToVFS('NotoIndic-Regular.ttf', mod.regular)
  pdf.addFont('NotoIndic-Regular.ttf', 'NotoIndic', 'normal')
  pdf.addFileToVFS('NotoIndic-Bold.ttf', mod.bold)
  pdf.addFont('NotoIndic-Bold.ttf', 'NotoIndic', 'bold')
  return 'NotoIndic'
}

export default registerPdfFont
